// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__H7HiI","header":"ReportDetails_header__1QwaV","title":"ReportDetails_title__2Uk-_","left":"ReportDetails_left__1hRKZ"};